import type { Ping } from '../../shared/wire';

export interface DeviceMeta {
  animals: string[];
  group: string[] | null;
  token: string;
  created: string;
  // The device's display tag (ADR 0022); null/undefined when unset. Hydrated
  // from the owner self-read and updated after a signed rename.
  tag?: string | null;
}

export const MOCK: { device: DeviceMeta | null; pings: Ping[] } = {
  device: null,
  // A device is a stream of timestamped GPS pings.
  // Sessions are derived from time-gap grouping, not stored metadata.
  pings: [],   // [{t: epoch_ms, lat, lng}]
};
